import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'validator/lib/isEmail';
import ErrorMessage from '../common/ErrorMessage.js';

class Search extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.search = this.search.bind(this);
        this.onKeywordChange = this.onKeywordChange.bind(this);
        this.formIsValid = this.formIsValid.bind(this);
    }

    componentWillMount() {
    }

    componentDidMount() {  
        this.props.actions.clearSearchError();
    }   
    
    search(event) {
        event.preventDefault();
        if(this.formIsValid()) {
            this.props.actions.browseGigs();
        }
    }

    onKeywordChange(event) {
        const value = event.target.value;
        this.props.actions.setKeyword(value);
    }

    formIsValid() {
        if(isEmpty(this.props.keyword)) {
            this.props.actions.setSearchError('Please enter an event name to search for');
            return false;
        }
        return true;
    }

    render() {
        return (
            <div id="search">
                <div className="searchbar-inline">
                    <div className="search-inner middle form">
                        <form id="frmSearchFilter" name="form-search" method="post" action="" onSubmit={this.search} className="form form-regular">
                            <ErrorMessage error={this.props.searchError} onClose={this.props.actions.clearSearchError} />
                            <div className="search-inner">
                                <input className="form-control inputfield transition" name="keyword" placeholder={`Search by event name`} value={this.props.keyword} onChange={this.onKeywordChange} />
                                <input id="btnSearch" type="submit" className="btn btn-primary btn-dark transition" value="SEARCH" />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

Search.propTypes = {
    keyword: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired,
    searchError: PropTypes.string
};

export default Search;


